/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Palette_TitleInputs */

const cs_builder_palette_title = /** @type {(inputs: Builder_Palette_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloky`)
};

const en_builder_palette_title = /** @type {(inputs: Builder_Palette_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocks`)
};

/**
* | output |
* | --- |
* | "Blocks" |
*
* @param {Builder_Palette_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_palette_title = /** @type {((inputs?: Builder_Palette_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Palette_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_palette_title(inputs)
	return cs_builder_palette_title(inputs)
});